module.exports = __webpack_public_path__ + "img/botox-logo.05cf0fb3.png";